import { originalCategory } from "./state";
export const mutations = {
	SET_CATEGORIES(state, payload) {
    state.categories = payload;
  },
  RESET_CURRENT_CATEGORY(state) {
    state.currentCategory = { ...originalCategory };
  },
  SET_CURRENT_CATEGORY(state, payload) {
    state.currentCategory = payload;
  },
  SET_SORT_FIELD(state, field) {
    state.sortBy.field = field;
  },
  SET_SORT_DIRECTION(state, dir) {
    state.sortBy.direction = dir;
  },
  setSearchQuery(state, term) {
    state.filters.searchQuery = term;
  },
}
